module.exports = __webpack_public_path__ + "static/media/polygon.e86f48f9.svg";